<div tiimeLargeProperty>
  Dossier :
  <div class="flex gap-5">
    @if (showRefresh()) {
      <app-refresh-button (refresh)="emitRefreshCompany()"></app-refresh-button>
    }
    @if (showNavigateToCompany()) {
      <button
        tiime-button
        icon
        color="primary"
        tiimeTooltip="Ouvrir le dossier dans un nouvel onglet"
        (click)="emitNavigateToCompany()"
      >
        <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
      </button>
    }
  </div>
</div>
@if (displayedProperties | includes: 'name') {
  <div tiimeProperty>
    <span class="nowrap">Nom</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ company?.name }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'reference') {
  <div tiimeProperty>
    <span class="nowrap">N°</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ company?.reference }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'legalForm') {
  <div tiimeProperty>
    <span class="nowrap">Forme juridique</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ company?.legalForm }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'siret') {
  <div tiimeProperty>
    <span class="nowrap">SIRET</span>
    <span
      class="italic ellipsis"
      tiimeTooltip="{{ company?.siret }}"
      [tooltipDisabled]="!company?.siret"
      tiimeFallbackText
    >
      {{ company?.siret | mask: siretMask }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'address') {
  <div tiimeProperty>
    <span class="nowrap">Adresse</span>
    <app-address-property
      [street]="company?.street"
      [postalCode]="company?.postalCode"
      [city]="company?.city"
      [withIcon]="false"
      tiimeFallbackText
    ></app-address-property>
  </div>
}
@if (displayedProperties | includes: 'apeCode') {
  <div tiimeProperty>
    <span class="nowrap">Code APE</span>
    <span
      class="italic ellipsis"
      tiimeTooltip="{{ company?.apeCode?.code }} - {{ company?.apeCode?.label }}"
      [tooltipDisabled]="!company?.apeCode"
      tiimeFallbackText
    >
      {{ company?.apeCode?.code }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'taxRegime') {
  <div tiimeProperty>
    <span class="nowrap">Régime d'imposition</span>
    <span
      class="italic ellipsis"
      [tiimeTooltip]="company?.taxRegime | taxRegimeLabel: taxRegimes : false"
      [tooltipDisabled]="!company?.taxRegime"
      tiimeFallbackText
    >
      {{ company?.taxRegime | taxRegimeLabel: taxRegimes }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'vatSystem') {
  <div tiimeProperty>
    <span class="nowrap">Régime de TVA</span>
    <span class="italic ellipsis" tiimeFallbackText>
      @if (company?.vatSystem; as vatSystem) {
        {{ vatSystem?.code | codeAndLabel: vatSystems : false }}
      }
    </span>
  </div>
}
@if (displayedProperties | includes: 'shareCapital') {
  <div tiimeProperty>
    <span class="nowrap">Capital social</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ company?.shareCapital | currency: 'EUR' }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'activityStartDate') {
  <div tiimeProperty>
    <span class="nowrap">Début d'activité</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ company?.activityStartDate | date: 'shortDate' }}
    </span>
  </div>
}
@if (displayedProperties | includes: 'missionEndDate') {
  <div tiimeProperty>
    <span class="nowrap">Fin de mission</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ company?.mission?.endDate | date: 'shortDate' }}
    </span>
  </div>
}
